// react
import React, { useState, useEffect } from "react";

// components
import DeviceCard from "../../components/Cards/dashboardCards/dashboardCardComponent";
import DeviceGraph from "../../components/graph/graphComponent";
import RadialGraph from "../../components/radialGraph/radialGraphComponent";
import StringCard from "../../components/stringCard/stringCardComponent";
import ErrorCard from "../../components/errorCard/errorCardComponent";

// mui
import { Grid, Typography, Skeleton } from "@mui/material";
import { BsGrid3X2GapFill } from "react-icons/bs";

// publicDashboard-Component
const PublicDashboard = (props) => {
  // .env variables
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const bodyUrl = process.env.REACT_APP_BODY_URL;

  // function for getting timezone from browser:
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const [timezone, setTimezone] = useState(timeZone);
  const [cardData, setCardData] = useState([]);
  const [isAttributeLoading, setIsAttributeLoading] = useState(true);
  const [noAttribute, setNoAttribute] = useState([]);

  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    setIsAttributeLoading(true);
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(`${baseUrl}/${bodyUrl}${props.devEUI}/${timezone}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setNoAttribute(result);
        setCardData(result.data);
        if (result.statusCode === 200) {
          setCardData(result.data);
          setIsAttributeLoading(false);
        } else if (result.statusCode === 404) {
          setNoAttribute(result);
          setIsAttributeLoading(true);
        } else if (result.statusCode === 500) {
          setNoAttribute(result);
          setIsAttributeLoading(true);
        }
        setIsAttributeLoading(false);
      })
      .catch((err) => {
        setIsAttributeLoading(false);
      });
  };
  return (
    <>
      <Grid
        container
        sx={{
          marginTop: { xs: "-50px", sm: "-25px", lg: "-30px", xl: "-30px" },
        }}
      >
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          sx={{
            marginTop: { xs: "96px", sm: "65px", md: "45px", lg: "50px" },
            position: { xs: "none", sm: "none", md: "fixed" },
            top: "10",
            marginBottom: { xs: "-10px", sm: "2px", md: "40px" },
            justifyContent: { xs: "center", sm: "start" },
            marginLeft: { sm: "60px" },
          }}
          alignContent="center"
        >
          <p style={{ fontSize: "15", fontWeight: "500" }}>
            Device Health Information
          </p>
        </Grid>
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={4}
          lg={3}
          xl={2.5}
          sx={{
            display: { xs: "grid", sm: "flex", md: "grid", lg: "flex" },
            padding: { md: "10px 0px" },
            mb: { xs: "-15px", sm: "-20px" },
            mt: { sm: "-45px", md: "69px", lg: "80px" },
            justifyContent: {
              xs: "center",
              sm: "space-between",
              md: "center",
              xl: "center",
            },
            height: { xs: "620px", sm: "340px", md: "600px", lg: "600px" },
            position: {
              xs: "none",
              sm: "none",
              md: "fixed",
              lg: "fixed",
              xl: "fixed",
            },
            overflow: { md: "scroll", xl: "none" },
            "&::-webkit-scrollbar": {
              display: { sm: "none", md: "none" },
            },
          }}
        >
          <>
            <Grid
              item
              xs={12}
              sm={6}
              md={12}
              lg={12}
              xl={12}
              sx={{
                padding: { sm: "10px", md: "0px" },
                mt: { xs: "10px", sm: "30px", md: "0" },
                mb: { xs: "-120px", md: "-36px", lg: "-43px", xl: "-48px" },
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <DeviceCard isLoading={props.isHealthLoad} />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={12}
              lg={12}
              xl={12}
              sx={{
                padding: "10px",
                display: "flex",
                mt: { xs: "-20px", sm: "30px", md: "-65px", lg: "-53px" },
                mb: { xs: "-100px" },
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <DeviceGraph devEUI={props.devEUI} />
            </Grid>
          </>
        </Grid>

        {/* Attribute Card Component */}
        {isAttributeLoading ? (
          <Grid
            item
            container
            xs={12}
            sm={12}
            md={8}
            lg={9}
            xl={9.5}
            ml="auto"
            sx={{
              // mt: { md: "40px", lg: "50px", xl: "50px" },
              mt: {
                xs: "-20px",
                sm: "10px",
                md: "69px",
                lg: "81px",
                xl: "80px",
              },
            }}
          >
            <Grid item container>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={4}
                xl={3}
                style={{
                  width: 300,
                  height: 285,
                }}
                sx={{
                  mt: { xs: "8px", md: "10px", lg: "10px", xl: "10px" },
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                }}
              >
                <Skeleton
                  variant="rounded"
                  width="300px"
                  sx={{ height: { xs: "268px", sm: "270px", md: "270px" } }}
                  animation="wave"
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={4}
                xl={3}
                sx={{
                  mt: { xs: "5px", md: "10px", lg: "10px", xl: "10px" },
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                }}
              >
                <Skeleton
                  variant="rounded"
                  width="300px"
                  sx={{ height: { xs: "268px", sm: "270px", md: "270px" } }}
                  animation="wave"
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={4}
                xl={3}
                sx={{
                  mt: {
                    xs: "21px",
                    sm: "10px",
                    md: "2px",
                    lg: "10px",
                    xl: "10px",
                  },
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                }}
              >
                <Skeleton
                  variant="rounded"
                  width="300px"
                  sx={{ height: { xs: "268px", sm: "300px", md: "270px" } }}
                  animation="wave"
                />
              </Grid>
            </Grid>
          </Grid>
        ) : (
          noAttribute.statusCode === 200 && (
            <Grid
              item
              container
              xs={12}
              sm={12}
              md={8}
              lg={9}
              xl={9.5}
              ml="auto"
              sx={{
                mt: {
                  xs: "-31px",
                  sm: "5px",
                  md: "69px",
                  lg: "81px",
                  xl: "80px",
                },
              }}
            >
              {cardData.map((item, index) => {
                switch (item.attribute_datatype) {
                  case "String":
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={4}
                        xl={3}
                        sx={{
                          padding: "10px",
                          display: "flex",
                          justifyContent: "center",
                          alignContent: "center",
                        }}
                      >
                        <StringCard value={item} key={index} />
                      </Grid>
                    );
                  case "Number": {
                    if (item.value !== "Data Unavailable") {
                      return (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg={4}
                          xl={3}
                          sx={{
                            padding: "10px",
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                          }}
                        >
                          <RadialGraph value={item} key={index} />
                        </Grid>
                      );
                    } else {
                      return (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg={4}
                          xl={3}
                          sx={{
                            padding: "10px",
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                          }}
                        >
                          <ErrorCard value={item} key={index} />
                        </Grid>
                      );
                    }
                  }
                }
              })}
            </Grid>
          )
        )}

        {noAttribute.statusCode === 404 && (
          <Grid
            item
            container
            xs={12}
            sm={12}
            md={8}
            lg={9}
            xl={9.5}
            ml="auto"
            sx={{
              mt: { md: "30px", lg: "30px", xl: "30px" },
              display: "grid",
              alignContent: "center",
              justifyContent: "center",
              padding: { xs: "20px", sm: "200px" },
            }}
          >
            <Grid
              item
              sx={{
                display: "flex",
                justifyContent: "center",
                color: "grey",
              }}
            >
              <BsGrid3X2GapFill sx={{ color: "#808080" }} />
            </Grid>
            <Grid item>
              <Typography
                color="#6c757d"
                sx={{ fontSize: "14px", fontWeight: "500" }}
              >
                {noAttribute.message}
              </Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
};
export default PublicDashboard;
